import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    input
} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {FieldComponent} from '../field/field.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: "woa-text-field",
    templateUrl: "./text-field.component.html",
    styleUrl: "./text-field.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: TextFieldComponent, multi: true}],
    imports: [
        FieldComponent,
        FormsModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextFieldComponent extends AbstractField {
    public readonly type: InputSignal<"text" | "url"> = input<"text" | "url">("text");
    public readonly inputMode: InputSignal<"text" | "numeric"> = input<"text" | "numeric">("text");
    public readonly autocomplete: InputSignal<"username" | "given-name" | "family-name" | "street-address" | "address-level2" | "address-level1" | "postal-code" | "new-password"> = input<"username" | "given-name" | "family-name" | "street-address" | "address-level2" | "address-level1" | "postal-code" | "new-password">();
    public readonly maxlength: InputSignal<string> = input<string>();
    public readonly spellcheck: InputSignal<boolean> = input<boolean>(true);
}
